/**
 * Type guard for an event with a valid DOM element event target.
 */
export function isDomEventTarget(
  e: Event,
): e is Event & { target: HTMLElement | SVGElement } {
  return e.target instanceof HTMLElement || e.target instanceof SVGElement
}
